import { useEffect, useRef } from "react";

import {
  SystemEventTypes,
  usePostSystemEventMutation,
} from "../redux/services/config";

export const useSystemLoadAnalytics = (
  screenId: string,
  isDebugMode: boolean,
  hasValidConfig: boolean,
) => {
  const [postSystemEvent] = usePostSystemEventMutation();
  const hasReportedSystemLoad = useRef(false);

  useEffect(() => {
    if (isDebugMode || !hasValidConfig || hasReportedSystemLoad.current) return;

    hasReportedSystemLoad.current = true;
    postSystemEvent({
      id: screenId,
      event: {
        event_type: SystemEventTypes.SYSTEM_LOAD,
        event_data: {
          type: window !== window.parent ? "embedded" : "native",
          device_height: window.innerHeight,
          device_width: window.innerWidth,
          screen_id: screenId,
        },
      },
    });
  }, [hasValidConfig, isDebugMode, postSystemEvent, screenId]);
};
